import React from 'react'
import {
    Card,
    Divider,
    PageHeader,
    Select,
    Button,
    Spin,
    Space,
    Alert
} from 'antd';
import { getYears, getSpecialReport } from '../util/APIUtils';
import FarmProfileSelect from '../common/FarmProfileSelect';


function SpecialContract() {
    const [loading, setLoading] = React.useState(false);
    const [years, setYears] = React.useState([]);
    const [year, setYear] = React.useState(null);
    const [farmProfileId, setFarmProfileId] = React.useState(null)
    const [format, setFormat] = React.useState('pdf');

    const fetchYears = React.useCallback(async () => {
        setLoading(true);
        let promise;
        promise = getYears();
        if (!promise) {
            return;
        }

        promise.then(response => {
            setYears(response.reverse())
            setLoading(false)

        }).catch(error => {
            setLoading(false)
        });
    }, [])

    React.useEffect(() => {
        fetchYears()
    }, [fetchYears]);

    const handleYearInput = (val) => {
        setYear(val)
        this.getReport(val);
    }

    const getReport = () => {
        let promise;
        promise = getSpecialReport(year, farmProfileId, format);
        if (!promise) {
            return;
        }
        setLoading(true)
        promise.then(response => {
            setLoading(false)

        }).catch(error => {
            setLoading(false)
        });
    }

    return (
        <div>
            <PageHeader
                className="site-page-header"
                title={"Standortprofil auftrag"}
            />
            <Card bordered={true} headStyle={{ padding: "0" }} loading={loading}>
                <Space>
                    <FarmProfileSelect setItem={setFarmProfileId} />
                    <Select style={{ width: '140px' }} onChange={setYear} defaultValue={year} placeholder={"Jahr"}>
                        {years.map(item => (
                            <Select.Option key={item.projectYear} value={item.projectYear}>
                                {item.projectYear}
                            </Select.Option>
                        ))}
                    </Select>


                    {farmProfileId && year &&
                        <Select style={{ width: '140px' }} onChange={setFormat} placeholder={"format"}>
                            <Select.Option key={1} value="pdf"> PDF</Select.Option>
                            <Select.Option key={2} value="docx"> Word</Select.Option>
                        </Select>
                    }

                    <Button onClick={getReport}>
                        Download
                    </Button>

                </Space><Divider></Divider>

            </Card>
        </div>
    )
}

export default SpecialContract